const LOADED = "loaded";
const RESIZED = "resized";
const ROUTE_CHANGE = "route_change";
const SCROLL_TO_TOP = "scroll_to_top";
const APP_INSTALLED = "app_installed";
const APP_REMOVED = "app_removed";
const APP_SETTINGS_OPENED = "app_settings_opened";
const APP_EVENT = "app_event";

const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

const sendPostMessage = (eventName, eventData) => {
  switch (eventName) {
    case LOADED:
    case RESIZED:
    case ROUTE_CHANGE:
    case SCROLL_TO_TOP:
    case APP_INSTALLED:
    case APP_REMOVED:
    case APP_SETTINGS_OPENED:
    case APP_EVENT:
      const message = JSON.stringify({
        event_name: eventName,
        event_data: eventData || null
      });
      //   return isInIframe() ? parent.postMessage(message, "*") : false;
      return parent.postMessage(message, "*");
    default:
      return false;
  }
};

export { isInIframe, sendPostMessage };



// WEBPACK FOOTER //
// /opt/build/repo/packages/utils/sendPostMessage.js